import { GruserType } from '@wix/da-gruser-shared/pkg/types';
import { URLS, Url } from '@wix/da-url';
import { ExhibitionistWidgetType } from './types';
import { isGroup } from '../../User/helpers';
export const getExhibitionistWidgetType = ({ gruser, zone: { name: zoneName } })=>{
    if (gruser.gruserTypeid === GruserType.Deviation) {
        return ExhibitionistWidgetType.STRIP_SHORT;
    } else {
        return zoneName === 'topBar' ? ExhibitionistWidgetType.STRIP : ExhibitionistWidgetType.TALL;
    }
};
export const getSubmitUrlForProfileOwner = (owner)=>{
    return isGroup(owner) ? Url.submissionLinkWithGroupId(owner.userId) : Url.to(URLS.SUBMIT);
};
